export enum EAPP_FLOWS {
  OFFERS = 'offers',
  AUTH = 'auth',
  ONBOARDING = 'onboarding',
  FAST_ONBOARDING = 'fast-onboarding',
  SCORE = 'score',
  CALCULATE_SCORE = 'calculate-score',
  INSTALLMENTS = 'installments',
  PAYMENT = 'payment',
  ERROR = 'error',
  FQA = 'frequent-questions',
  VALIDATIONS = 'validations',
  COMPLETED_PROFILE = 'completed-profile',
  CARD_VALIDATION = 'card-validation',
  ONBOARDING_WITHOUT_PURCHASE = 'onboarding-without-purchase',
  PAYMENT_PLAN = 'payment-plan',
}

export enum ETRANSACTION_STATUS {
  PENDING = 'pending',
  PROCESSED = 'processed',
  CANCELED = 'canceled',
  EXPIRED = 'expired',
}
